import api from "@utils/api";

export const getAllCarRegistry = () => api.get("/car_registry");
export const getCarRegistryByPlaceId = (id) =>
  api.get(`/car_registry/place/${id}`);
export const getCarRegistryById = (id) => api.get(`/car_registry/${id}`);

export const createCarRegistry = (car) => api.post("/car_registry", car);
export const updateCarRegistry = (id, car) =>
  api.put(`/car_registry/${id}`, car);
export const deleteCarRegistry = (id) => api.delete(`/car_registry/${id}`);
export const getCarRegistryByCarId = () =>
  api.get(`/car_registry/car/${id}`, car);
export const getCarRegistryByPlaceIdPaginated = (id, page, per_page) =>
  api.get(`/car_registry/place/${id}?page=${page}&per_page=${per_page}`);

export const getCarRegistryPaginated = (idOrg, page, per_page) =>
  api.get(
    `/car_registry/organizacion/${idOrg}?page=${page}&per_page=${per_page}`
  );
export const getCarByLicensePlate = (license_plate, page, per_page) =>
  api.get(
    `/car_registry/car/license_plate/${license_plate}?page=${page}&per_page=${per_page}`
  );

export const getFilterCarRegistryByDate = (
  placeId,
  startDate,
  endDate,
  page,
  perPage
) =>
  api.get(
    `/car_registry/filter/${placeId}?start_date=${startDate}&end_date=${endDate}&page=${page}&per_page=${perPage}`
  );

export const getExcelCarRegistryS3 = async (organizacion_id, desde, hasta) => {
  try {
    const response = await api.get(
      `/car_registry/export/excel_s3?organizacion_id=${organizacion_id}&desde=${desde}&hasta=${hasta}`
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel: ${error.message}`);
  }
};
